import { FontEntry } from '../../types/font'

export const everett: FontEntry = {
  displayName: 'Everett',
  weights: {
    300: {
      normal: { file: 'TWKEverett-Light', extension: 'woff', format: 'woff' },
      italic: { file: 'TWKEverett-LightItalic', extension: 'woff2', format: 'woff2' }
    },
    400: {
      normal: { file: 'TWKEverett-Regular', extension: 'woff2', format: 'woff2' },
      italic: { file: 'TWKEverett-RegularItalic', extension: 'woff', format: 'woff' }
    },
    700: {
      normal: { file: 'TWKEverett-Bold', extension: 'woff2', format: 'woff2' },
      italic: { file: 'TWKEverett-BoldItalic', extension: 'woff2', format: 'woff2' }
    }
  }
}
